mutation BookCampaign($input: BookCampaignInput!) {
  bookCampaign(input: $input)
}
